var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Device Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device-settings-NextGen-POS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device-settings-Menu-Login",
    transform: "translate(-40.000000, -345.000000)",
    fill: "#6F6F6F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device-settings-Group-6",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device-settings-Text-Labels",
    transform: "translate(1.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device-settings-Icon-&-Text-Label"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.934641, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device-settings-Device",
    transform: "translate(0.565359, 0.536458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,3.03125 L12,3.03125 L12,5.05208333 L23,5.05208333 C23.5522847,5.05208333 24,4.59970438 24,4.04166667 C24,3.48362895 23.5522847,3.03125 23,3.03125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,5.05208333 L6,5.05208333 L6,8.08333333 L10,8.08333333 L10,0 L6,0 L6,3.03125 L1,3.03125 C0.44771525,3.03125 0,3.48362895 0,4.04166667 C0,4.59970438 0.44771525,5.05208333 1,5.05208333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19.1979167 L12,19.1979167 L12,21.21875 L23,21.21875 C23.5522847,21.21875 24,20.766371 24,20.2083333 C24,19.6502956 23.5522847,19.1979167 23,19.1979167 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,21.21875 L6,21.21875 L6,24.25 L10,24.25 L10,16.1666667 L6,16.1666667 L6,19.1979167 L1,19.1979167 C0.44771525,19.1979167 0,19.6502956 0,20.2083333 C0,20.766371 0.44771525,21.21875 1,21.21875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,11.1145833 L20,11.1145833 L20,13.1354167 L23,13.1354167 C23.5522847,13.1354167 24,12.6830377 24,12.125 C24,11.5669623 23.5522847,11.1145833 23,11.1145833 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,13.1354167 L14,13.1354167 L14,16.1666667 L18,16.1666667 L18,8.08333333 L14,8.08333333 L14,11.1145833 L1,11.1145833 C0.44771525,11.1145833 0,11.5669623 0,12.125 C0,12.6830377 0.44771525,13.1354167 1,13.1354167 Z",
    id: "Path"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/Device.fc3aba4f.svg";
export { ForwardRef as ReactComponent };